import { LOCALITY_FILTERS, type LocalityFilter, type LocalityGroup } from '@shared/locality';

interface LocalityFilterRowProps {
  value: LocalityFilter;
  onChange: (next: LocalityFilter) => void;
  counts?: Partial<Record<LocalityGroup, number>>;
  loading?: boolean;
}

/** Everywhere / In Ranch / Outside — same segment track Places uses. */
export function LocalityFilterRow({ value, onChange, counts, loading = false }: LocalityFilterRowProps) {
  return (
    <div className="segment-row" role="tablist" aria-label="Location">
      {LOCALITY_FILTERS.map((f) => (
        <button
          key={f.key}
          type="button"
          role="tab"
          aria-selected={value === f.key}
          className={`segment ${value === f.key ? 'segment--active' : ''}`}
          onClick={() => onChange(f.key)}
        >
          {f.label}
          {!loading && f.key !== 'both' && counts && (
            <span className="segment__count">{counts[f.key] ?? 0}</span>
          )}
        </button>
      ))}
    </div>
  );
}
